// Messaging product types
export enum MessagingProducts {
  WHATSAPP = 'whatsapp',
  INSTAGRAM = 'instagram',
  EMAIL = 'email',
  SMS = 'sms',
}

// Template status for WhatsApp templates
export enum TemplateStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  PAUSED = 'PAUSED',
}

// Conversation interface for frontend
export interface Conversation {
  _id: string;
  agent_id: string;
  customer_id: string;
  status: 'active' | 'closed' | 'waiting';
  created_at: string;
  updated_at: string;
  ended_at?: string; // Optional for RealtimeProvider compatibility
  last_message?: {
    content: string;
    timestamp: string;
    sender: 'customer' | 'agent';
  };
  metadata?: {
    channel: MessagingProducts;
    customer_name?: string;
    customer_phone?: string;
    tags?: string[];
  };
  tags?: Array<{
    name: string;
    color?: string;
    _id?: string;
  }>; // For RealtimeProvider compatibility
}

// Message interface for frontend
export interface Message {
  _id: string;
  conversation_id: string;
  content: string;
  sender: 'customer' | 'agent' | 'system';
  timestamp: string;
  type: 'text' | 'image' | 'audio' | 'video' | 'document' | 'template';
  metadata?: {
    channel: MessagingProducts;
    template_id?: string;
    media_url?: string;
    media_type?: string;
  };
}

// Quick reply interface
export interface QuickReply {
  _id: string;
  agent_id: string;
  title: string;
  content: string;
  tags?: string[];
  created_at: string;
}

// Campaign interface
export interface Campaign {
  _id: string;
  agent_id: string;
  name: string;
  message_template: string;
  target_audience: string[];
  status: 'draft' | 'scheduled' | 'sent' | 'failed';
  created_at: string;
  scheduled_at?: string;
  sent_at?: string;
}
